<script>
	import { onMount } from "svelte";
	import { logEvent } from "firebase/analytics";
	export let sessionData;
	export let gameData;
	export let analytics;

	// console.log(gameData);
	// console.log(gameData.conclData.background);

	let theme = {
		// background: gameData.conclData.background?
		score_cup: gameData.conclData.score_cup
			? gameData.conclData.score_cup
			: "../gamedata/default/score-cup.png",
		background_color: gameData.conclData.background_color
			? gameData.conclData.background_color
			: "#031f4b",
		team_color: gameData.conclData.team_color
			? gameData.conclData.team_color
			: "#ffffff",
		mission_color: gameData.conclData.mission_color
			? gameData.conclData.mission_color
			: "#47e4bf",
		game_color: gameData.conclData.game_color
			? gameData.conclData.game_color
			: "#ffffff",
		score_color: gameData.conclData.score_color
			? gameData.conclData.score_color
			: "#05204a",
		score_background: gameData.conclData.score_background
			? gameData.conclData.score_background
			: "#ffffff",
		score_shadow: gameData.conclData.score_shadow
			? gameData.conclData.score_shadow
			: "#093986",
		font_face: gameData.conclData.font_face
			? gameData.conclData.font_face
			: "sofia_sans, sans-serif",
	};

	// console.log(theme);

	export let lang = "en";
	let score = sessionData.totalScore;
	let hints = sessionData.usedHintsCount;
	let missionName =
		typeof sessionData.game.name === "object"
			? sessionData.game.name[lang]
			: sessionData.game.name;
	let teamName = sessionData.session.team_name;
	export let background = "../gamedata/default/scorebg-{lang}.webp";
	export let text = "completed the mission";

	let bg_link = background
		? background.indexOf("{lang}")
			? background.replace("{lang}", lang)
			: background
		: "../gamedata/default/scorebg-" + lang + ".webp";

	// let cup_link = "../gamedata/default/score-cup.webp";
	let cup_link = theme.score_cup;

	let imgBlob = "loading";
	let c, ctx;
	let cup_loaded = false;
	let bg_loaded = false;
	let final_draw = false;
	// let fn = function () {
	//     console.log('Loading...');
	// };

	// $: lang, bg_link, fn();

	onMount(async () => {
		// fn = function () {
		c = document.getElementById("scoreCanvas");
		ctx = c.getContext("2d");

		ctx.fillStyle = theme.background_color;
		ctx.fillRect(0, 0, 1080, 1920);

		function fitTextOnCanvas(
			text,
			baseFontSize,
			fontface,
			fontWeight,
			xPosition,
			yPosition,
		) {
			var fontsize = baseFontSize;

			// lower the font size until the text fits the canvas
			do {
				fontsize--;
				ctx.font = fontWeight + " " + fontsize + "px " + fontface;
			} while (ctx.measureText(text).width > c.width - 40);

			// draw the text
			ctx.fillText(text, xPosition, yPosition);
		}

		//     // ctx.globalCompositeOperation = "lighter";
		let base_image = new Image();
		base_image.src = bg_link;
		// base_image.crossOrigin = "anonymous";

		let cup_image = new Image();
		cup_image.src = cup_link;
		// cup_image.crossOrigin = "anonymous";

		base_image.onload = function () {
			bg_loaded = true;
			// alert('bg-loaded');
			drawIt();
		};
		cup_image.onload = function () {
			cup_loaded = true;
			// alert('cup-loaded');
			drawIt();
		};

		function drawIt() {
			if (cup_loaded && bg_loaded) {
				ctx.drawImage(base_image, 0, 0, 1080, 1920);

				ctx.textAlign = "center";

				ctx.fillStyle = theme.team_color; //white
				// ctx.fillStyle = '#ff0000'; //red
				fitTextOnCanvas(teamName, 81, theme.font_face, 600, 540, 962);

				ctx.fillStyle = theme.mission_color; //teal
				// ctx.fillStyle = '#ff0000'; //red
				fitTextOnCanvas(
					text.completed_the_mission,
					61,
					theme.font_face,
					600,
					540,
					1052,
				);

				ctx.fillStyle = theme.game_color; //white
				// ctx.fillStyle = '#ff0000'; //red
				fitTextOnCanvas(missionName, 61, theme.font_face, 600, 540, 1142);

				let commonScore =
					score != 1 ? score + " " + text.points : score + " " + text.point;

				fitTextOnCanvas("", 81, theme.font_face, 500, 540, 1307);

				let x = ctx.measureText(commonScore).width;
				let p = 42; //padding
				let o = 10; //bg offset

				// width = x+2*p+152+10

				ctx.fillStyle = theme.score_shadow; //blue
				ctx.fillRect(
					(c.width - (x + p * 2 + 152 + o)) / 2 + o,
					1205 + o,
					x + p * 2 + 152 + o,
					152,
				);
				ctx.fillStyle = theme.score_background; //white
				ctx.fillRect(
					(c.width - (x + p * 2 + 152 + o)) / 2,
					1205,
					x + p * 2 + 152 + o,
					152,
				);

				ctx.drawImage(
					cup_image,
					(c.width - (x + p * 2 + 152 + o)) / 2,
					1205,
					152,
					152,
				);
				ctx.fillStyle = theme.score_color; //blue  093986
				ctx.textAlign = "left";

				fitTextOnCanvas(
					commonScore,
					81,
					theme.font_face,
					500,
					(c.width - (x + p * 2 + 152 + o)) / 2 + 152 + p + o,
					1307,
				);

				final_draw = true;
			}
			imgBlob = c.toDataURL("image/png");
		}
		// };
		// fn();
	});
</script>

<!-- <p class="font-medium opacity-50 lg:h-0 lg:absolute">Copyright VG 2022</p> -->

<p style="font-family:{theme.font_face}; opacity:0; width:1px; height:1px">
	Зареждане / Loading
</p>

<canvas
	id="scoreCanvas"
	width="1080"
	height="1920"
	style="display:none; opacity:0; position:absolute;"
/>
<br />

<p class={imgBlob == "loading" ? "animate-pulse" : " hidden"}>
	{text.generating}
</p>
<img
	src={imgBlob}
	alt="Score card"
	class={imgBlob == "loading"
		? "h-0 border-none opacity-0 transition ease-out duration-300"
		: "max-h-screen border-4 border-white opacity-100 transition ease-out duration-300"}
/>
<a
	download={teamName +
		" " +
		missionName +
		" " +
		score +
		" " +
		text.poins +
		" vutreshenglas.com.webp"}
	href={imgBlob}
	title={"Score " + score + " " + teamName + " vutreshenglas.com"}
	class="text-link"
	on:click={() => logEvent(analytics, "score_card_shared")}
>
	<button
		class={imgBlob == "loading"
			? "secondary opacity-0 h-0 transition ease-out duration-300"
			: "secondary transition ease-out duration-300"}
	>
		<i class="fa-solid fa-download" data-position="left" />{text.download_share}
	</button>
</a>
